// extracted by mini-css-extract-plugin
export default {"donationCont":"Donation_donationCont__hQoA0","donationInput":"Donation_donationInput__LQTAC","submitBut":"Donation_submitBut__rrClj"};